import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconSave from "components/IconComponent/IconSave";

const ButtonSaveIcon = ({isSubmit = false, onClick, textButton='breadcrumb.save', ...props}) => {
    const {t} = useTranslation();

    return (
        <LoadingButton
            className="button-header"
            variant="contained"
            size="small"
            loading={isSubmit}
            loadingPosition="start"
            startIcon={<IconSave color={props?.disabled ? '#8F9294' : 'white'}/>}
            onClick={() => {
                onClick();
            }}
            {...props}
        >
            <Box sx={{ display: { xs: 'none', md: 'flex' } }} style={{ fontWeight: '700' }}>
                {t(textButton)}
            </Box>
        </LoadingButton>
    )
}

export default ButtonSaveIcon